export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-chat-smile-2-fill text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-bold font-heading text-foreground-950 whitespace-nowrap">
                在线吃瓜
              </span>
            </div>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
              51在线吃瓜今日吃瓜入口，每日提供最新爆料、今日热点和今日吃瓜视频。坚持理性吃瓜理念，做全网最专业的每日吃瓜聚合平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#about" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</a>
              <a href="#topics" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">热门话题</a>
              <a href="#updates" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">最新快讯</a>
              <a href="#faq" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">
              热门专题
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">主题合集</a>
              <a href="#cards" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">今日必看</a>
              <a href="#media" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">吃瓜视频</a>
              <a href="#carousel" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">深度专题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">
              合作伙伴
            </h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            &copy; 2026 在线吃瓜 - 51在线吃瓜今日吃瓜入口 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">首页</a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">联系我们</a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">帮助</a>
          </div>
        </div>
      </div>
    </footer>
  );
}